export const BalanceFlowSkeleton = () => {
  return (
    <div className="flex grow flex-1 flex-col h-full  px-[2.5rem] pt-[0.625rem] pb-[1.5rem]  overflow-y-auto ">
      <div className="flex  flex-1 gap-[1.25rem] pt-[3rem]">
        <div className=" bg-white flex  overflow-auto shadow-md h-full basis-1/5 animate-pulse opacity-50"></div>
        <div className=" bg-white flex flex-1 overflow-auto shadow-md basis-4/5 h-full animate-pulse opacity-50"></div>
      </div>
    </div>
  );
};
